(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-image.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-image.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useRef,
  useMemo,
  memo
} = React;
const {
  Image
} = svs.content.image_v2;

const TicketSkinImage = memo(_ref => {
  let {
    image,
    number
  } = _ref;
  return React.createElement(Image, {
    cssSelectors: "ticket-skin-shadow",
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: "Lott-".concat(number)
    })
  });
});
const PreloadSkinImages = _ref2 => {
  let {
    ticketInfo,
    onLoaded
  } = _ref2;
  const ref = useRef(null);
  useEffect(() => {
    let numberOfImagesNotLoaded = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.variations;
    const decreaseNumberOfImagesNotLoaded = () => {
      if (--numberOfImagesNotLoaded === 0) {
        onLoaded();
      }
    };
    if (ref.current) {
      ref.current.querySelectorAll('img').forEach(img => {
        if (img.complete) {
          decreaseNumberOfImagesNotLoaded();
        } else {
          img.onload = decreaseNumberOfImagesNotLoaded;
          img.onerror = decreaseNumberOfImagesNotLoaded;
        }
      });
    }
  }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type, ref]);
  const skinsToRender = useMemo(() => {
    const skinsToRender = [];
    for (let i = 0; i < (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.variations); i++) {
      const skin = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.skins[i];
      skinsToRender.push( React.createElement("div", {
        key: skin.url
      }, React.createElement(TicketSkinImage, {
        image: skin.image,
        number: i + 1
      })));
    }
    return skinsToRender;
  }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
  return React.createElement("div", {
    ref: ref,
    style: {
      display: 'none'
    }
  }, skinsToRender);
};
setGlobal('svs.tickets.play.components.TicketSkinImage', TicketSkinImage);
setGlobal('svs.tickets.play.components.PreloadSkinImages', PreloadSkinImages);

 })(window);